import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

export default class Steps extends React.Component {
  constructor(props) {
    super(props)

    this.config = { 
      types : [
        {
          title: 'default',
          isDefault: true,
        },
        'darkest'
      ],
      modifiers : [ 
        'xs',
        'sm',
        'md',
        'lg',
        'scroll'
      ],
      states : []
    }

    this.state = {
      scrollLeft: 0
    }
    this.scroller = React.createRef();
  }

  renderListStep(steps, props) { 
    const list = steps.map((value, index) => 
      <li key={index} className={`mdn-Steps-list-item mdn-Steps-list-item--${value.status}` + (value.status === 'disabled' ? 'mdn-Steps-list-item--disabled' : '')}>
        <p className={"mdn-Steps-text mdn-Heading " + ((props.inverse || props.darkest) ? 'mdn-Heading--inverse' : '') }>
          {value.title}
        </p>
      </li>
    )
    return list
  }

  componentDidMount() {
    this.update(this.props)
  }

  update(props) {
    const scrollLeft = props.scrollLeft
    const current = this.scroller.current
    current && scrollLeft && this.setState({scrollLeft}, () => {
       (current.scrollLeft = this.state.scrollLeft)
    })
  }

  render() {
    const {data, inverse, dataSteps, scrollLeft, ...rest} = this.props
    if(scrollLeft != this.state.scrollLeft) {
      this.setState({scrollLeft}, ()=>{this.update(this.props)})
    }
    return <div {...rest} className={resolveProps(this.props, this.config, 'Steps')} ref={this.scroller}>
      <ul className="mdn-Steps-list">
        {this.renderListStep(data || dataSteps, this.props)}
      </ul>
    </div>
  }
}

Steps.propTypes = {
  dataSteps : PropTypes.array
}